<template> 
  <div >
    <nav-header></nav-header>
    <div class="page-content" style="padding-top:10px;">
      <b-row >      
        <b-col cols="2">
          <nav-profile
            :documents="json.Documents"
          ></nav-profile>  
        </b-col>
        <b-col cols="9">
          <template v-for="(document, index) in json.Documents" >
            <CardRequest
              :key="index"
              :title="document.title"
              :linkNav="document.linkNav"
              :description="document.description"
              :titleRequest="document.titleRequest"
              :codeRequest="document.codeRequest"
              :codeResponse="document.codeResponse"
              :exceptions="document.exceptions"
              :route="document.route"
              :curlExample="document.curlExample"
              :configLinks="document.configLinks"
            />
          </template>          
        </b-col>
      </b-row>  
    </div>
    <user-profile-footer></user-profile-footer>
  </div>
</template>

<script>
import NavProfile from '../components/NavProfile.vue'
import NavHeader from '../components/NavHeader.vue'
import UserProfileFooter from '../components/UserProfileFooter.vue'
import CardRequest from '../components/CardRequest.vue'

export default {
  components: {
    NavProfile,
    UserProfileFooter,
    NavHeader,
    CardRequest
  },
  data() {    
    return {
      json: {}
    }
  },
  created(){
    this.json = require("../assets/json/document.json");
  }
}
</script>

<style >
  .row{
    margin-left: 0px !important;
    margin-right: 0px !important
  }
  p, span {
    text-align: left;
  }

  h2 {
    text-align: left;
  }

  hr {
    border-color: #861f1f !important;
    border:10 !important;
    margin-top: 0rem !important;
  }

  .card-header {
    text-align: left;
  }

  pre {
    background-color: #f1f1f1;
    text-align: left;
  }
</style>
